import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../../lib/supabase'

const PAGE = 50

export default function RoguesGallery() {
  const navigate = useNavigate()
  const [villains, setVillains] = useState([])
  const [loading, setLoading] = useState(true)
  const [limit, setLimit] = useState(PAGE)
  const [exhausted, setExhausted] = useState(false)

  useEffect(() => {
    let cancelled = false
    const fetchPage = async () => {
      setLoading(true)
      const { data, error } = await supabase.rpc('public_villains', { limit_n: limit })
      if (cancelled) return
      if (!error && Array.isArray(data)) {
        setVillains(data)
        if (data.length < limit) setExhausted(true)
      }
      setLoading(false)
    }
    fetchPage()
    return () => { cancelled = true }
  }, [limit])

  return (
    <div style={{ background: '#000', color: '#ff0055', fontFamily: "'Share Tech Mono', monospace", minHeight: '100vh', overflowX: 'hidden' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Share+Tech+Mono&family=Bebas+Neue&family=Space+Grotesk:wght@700;800&family=Cinzel+Decorative:wght@700;900&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        .scanlines{position:fixed;inset:0;background:repeating-linear-gradient(0deg,transparent,transparent 2px,rgba(0,0,0,0.08) 2px,rgba(0,0,0,0.08) 3px);pointer-events:none;z-index:100}
        .grid-bg{position:fixed;inset:0;background-image:linear-gradient(rgba(255,0,80,0.025) 1px,transparent 1px),linear-gradient(90deg,rgba(255,0,80,0.025) 1px,transparent 1px);background-size:28px 28px;pointer-events:none;z-index:0}
        @keyframes pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:0.3;transform:scale(1.4)}}
        @keyframes panelIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}
        .panel{position:relative;border:1px solid rgba(255,0,80,0.45);background:radial-gradient(ellipse at 30% 20%,#15000a 0%,#080004 70%,#040002 100%);padding:14px 14px 50px;overflow:hidden;animation:panelIn 0.4s ease both;min-height:240px}
        .panel:nth-child(2n){animation-delay:0.04s}
        .panel:nth-child(3n){animation-delay:0.08s}
        .panel-stamp{position:absolute;top:10px;right:-14px;transform:rotate(18deg);border:1.5px solid #ff0055;color:#ff0055;padding:2px 10px;font-family:'Space Grotesk',sans-serif;font-weight:800;font-size:8px;letter-spacing:2px;opacity:0.7;background:rgba(0,0,0,0.4)}
        .panel-name{font-family:'Cinzel Decorative',serif;font-weight:900;font-size:18px;line-height:1.05;color:#ff0055;text-shadow:0 0 12px rgba(255,0,80,0.4);word-break:break-word;margin-top:14px;margin-bottom:8px}
        .panel-attr{position:absolute;bottom:8px;right:10px;text-align:right;font-size:8px;color:rgba(255,0,80,0.65);letter-spacing:0.5px}
        .panel-attr-num{font-family:'Bebas Neue',sans-serif;font-size:14px;color:#ff0055;line-height:1}
        .ghost-btn{display:inline-block;background:none;border:1px solid rgba(255,0,80,0.4);color:#ff0055;font-family:'Share Tech Mono',monospace;font-size:11px;padding:11px 16px;cursor:pointer;letter-spacing:1.5px;text-decoration:none;transition:all 0.2s}
        .ghost-btn:hover{background:rgba(255,0,80,0.08);border-color:#ff0055}
        .forge-btn{background:#ff0055;color:#000;border:none;padding:14px 22px;font-family:'Share Tech Mono',monospace;font-size:13px;letter-spacing:2px;cursor:pointer;font-weight:700;transition:all 0.2s}
        .forge-btn:hover{background:#fff;box-shadow:0 0 30px rgba(255,0,80,0.5)}
      `}</style>

      <div className="scanlines" />
      <div className="grid-bg" />

      <div style={{ maxWidth: 720, margin: '0 auto', padding: '0 0 80px', position: 'relative', zIndex: 2 }}>

        {/* TOP BAR */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid rgba(255,0,80,0.15)' }}>
          <button className="ghost-btn" style={{ padding: '6px 10px', fontSize: 10 }} onClick={() => navigate('/dashboard')}>← DASHBOARD</button>
          <div style={{ fontSize: 10, color: 'rgba(255,0,80,0.65)', letterSpacing: 2 }}>// 05 · ROGUES_GALLERY</div>
        </div>

        {/* HERO */}
        <div style={{ padding: '24px 20px 16px' }}>
          <div style={{ fontSize: 9, letterSpacing: 3, color: 'rgba(255,0,80,0.6)', marginBottom: 8 }}>// THE_VAULT</div>
          <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 56, color: '#ff0055', letterSpacing: -2, lineHeight: 0.9, textShadow: '0 0 30px rgba(255,0,80,0.3)' }}>
            ROGUES<br/>GALLERY
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginTop: 14 }}>
            <div style={{ fontSize: 11, color: 'rgba(255,0,80,0.65)', lineHeight: 1.6, paddingLeft: 12, borderLeft: '2px solid rgba(255,0,80,0.4)', flex: 1 }}>
              Every villain forged by every member. Permanent record.
            </div>
            <div style={{ fontSize: 10, color: 'rgba(255,0,80,0.55)', letterSpacing: 2, marginLeft: 12 }}>
              {loading ? 'LOADING...' : `${villains.length} ON FILE`}
            </div>
          </div>
        </div>

        {/* CONTENT */}
        <div style={{ padding: '0 20px' }}>
          {loading && villains.length === 0 ? (
            <div style={{ padding: '60px 0', textAlign: 'center', fontSize: 12, color: 'rgba(255,0,80,0.55)', letterSpacing: 2 }}>
              <div style={{ marginBottom: 10, fontFamily: "'Bebas Neue', sans-serif", fontSize: 32, color: '#ff0055' }}>OPENING VAULT...</div>
              <div>// PULLING DOSSIERS</div>
            </div>
          ) : villains.length === 0 ? (
            <div style={{ padding: '60px 20px', textAlign: 'center', border: '1px dashed rgba(255,0,80,0.3)', marginBottom: 20 }}>
              <div style={{ fontFamily: "'Cinzel Decorative', serif", fontWeight: 900, fontSize: 22, color: '#ff0055', lineHeight: 1.3, marginBottom: 18, textShadow: '0 0 18px rgba(255,0,80,0.4)' }}>
                "THE VAULT IS EMPTY.<br/>BE THE FIRST TO BE FORGED."
              </div>
              <button className="forge-btn" onClick={() => navigate('/app/villain')}>▶ FORGE YOUR VILLAIN</button>
            </div>
          ) : (
            <>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 }}>
                {villains.map(v => {
                  const shortOrigin = v.origin && v.origin.length > 80 ? v.origin.slice(0, 80).trimEnd() + '…' : v.origin
                  return (
                    <div key={v.id} className="panel">
                      <div className="panel-stamp">CLASSIFIED</div>
                      <div style={{ fontSize: 7, letterSpacing: 2, color: 'rgba(255,0,80,0.55)' }}>// DOSSIER_NO_{String(v.member_number).padStart(4, '0')}</div>
                      <div className="panel-name">{v.villain_name}</div>
                      <div style={{ height: 1, background: 'linear-gradient(90deg, #ff0055, transparent)', margin: '0 0 8px' }} />
                      <div style={{ fontSize: 7, letterSpacing: 2, color: 'rgba(255,0,80,0.6)', marginBottom: 3 }}>// ORIGIN</div>
                      <div style={{ fontSize: 10, color: 'rgba(255,0,80,0.85)', lineHeight: 1.5, marginBottom: 8 }}>
                        {shortOrigin}
                      </div>
                      <div style={{ fontSize: 7, letterSpacing: 2, color: 'rgba(255,0,80,0.6)', marginBottom: 3 }}>// POWERS</div>
                      <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 8px', fontSize: 10, color: 'rgba(255,0,80,0.85)', lineHeight: 1.4 }}>
                        {(v.powers || []).map((p, i) => (
                          <li key={i} style={{ paddingLeft: 12, position: 'relative', marginBottom: 2 }}>
                            <span style={{ position: 'absolute', left: 0, color: '#ff0055' }}>▸</span>{p}
                          </li>
                        ))}
                      </ul>
                      <div style={{ fontSize: 7, letterSpacing: 2, color: 'rgba(255,0,80,0.6)', marginBottom: 3 }}>// WEAKNESS</div>
                      <div style={{ fontSize: 10, color: 'rgba(255,0,80,0.55)', fontStyle: 'italic', lineHeight: 1.4, paddingRight: 60 }}>
                        {v.weakness}
                      </div>
                      <div className="panel-attr">
                        <div className="panel-attr-num">#{v.member_number}</div>
                        <div>{v.member_display_name || '—'}</div>
                      </div>
                    </div>
                  )
                })}
              </div>

              <div style={{ textAlign: 'center', marginTop: 24 }}>
                {exhausted ? (
                  <div style={{ fontSize: 10, color: 'rgba(255,0,80,0.45)', letterSpacing: 2, padding: '14px 0' }}>
                    // END OF FILE · {villains.length} DOSSIERS
                  </div>
                ) : (
                  <button className="ghost-btn" onClick={() => setLimit(l => l + PAGE)} disabled={loading}>
                    {loading ? 'LOADING...' : '▶ LOAD 50 MORE'}
                  </button>
                )}
                <div style={{ marginTop: 14 }}>
                  <button className="forge-btn" onClick={() => navigate('/app/villain')}>▶ FORGE YOUR VILLAIN →</button>
                </div>
              </div>
            </>
          )}
        </div>

        <div style={{ padding: '24px 20px 12px', borderTop: '1px solid rgba(255,0,80,0.08)', marginTop: 32, display: 'flex', justifyContent: 'space-between', fontSize: 8, color: 'rgba(255,0,80,0.35)', letterSpacing: 1.5 }}>
          <span>2DOLLARSITES.COM</span>
          <span>VAULT OPEN 24/7</span>
          <span>EST.2026</span>
        </div>
      </div>
    </div>
  )
}
